import { ClipLoader } from "react-spinners";
import { BiSolidError, BiSolidCheckCircle } from "react-icons/bi";

export function IncidentModal({ modal, state, actions, t }) {
    if (!modal.isOpen) return null;
    return (
        <form onSubmit={(e) => e.preventDefault()}>
            <div className="modal show">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4>{modal.title}</h4>
                        {!modal.uncloseable && (
                            <span className="close" onClick={actions.closeModal}>&times;</span>
                        )}
                    </div>

                    <div className="modal-body">
                        {modal.kind === "message" && (
                            <div style={{ whiteSpace: "pre-line" }}>{modal.message}</div>
                        )}

                        {modal.kind === "update" && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="update-comments" className="required">
                                        {t("additionalComments")}
                                    </label>
                                    <textarea
                                        id="update-comments"
                                        rows={5}
                                        required
                                        value={state.updateForm.comments}
                                        onChange={(e) => actions.setUpdateComments(e.target.value)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="update-attachment">
                                        {t("attachments")}{t("maximumAllowed")}
                                    </label>
                                    <input
                                        id="update-attachment"
                                        type="file"
                                        accept=".png, .pdf, .heic"
                                        onChange={actions.onAttachmentChange}
                                    />

                                    <div
                                        style={{
                                            marginTop: 4,
                                            marginLeft: 4,
                                            color: "#666",
                                            fontSize: 12,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 10,
                                            width: "100%",
                                        }}
                                    >
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            {state.attachmentDisplayName || "No file selected (optional)."}
                                        </div>

                                        {state.hasAttachment && (
                                            <button
                                                type="button"
                                                className="incident-buttons"
                                                onClick={actions.clearAttachment}
                                                style={{
                                                    padding: "4px 8px",
                                                    backgroundColor: "#000",
                                                    cursor:
                                                        state.fileState.isConverting || state.fileValidation.status === "loading"
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    fontSize: 12,
                                                    width: "140px",
                                                    maxWidth: "25%",
                                                    marginTop: 0,
                                                }}
                                                disabled={state.fileState.isConverting || state.fileValidation.status === "loading"}
                                                title={
                                                    state.fileState.isConverting || state.fileValidation.status === "loading"
                                                        ? "Wait until processing finishes"
                                                        : "Remove attachment"
                                                }
                                            >
                                                <b>Remove</b>
                                            </button>
                                        )}
                                    </div>


                                    <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            {state.fileState.isConverting || state.fileValidation.status === "loading" ? (
                                                <>
                                                    <ClipLoader size={18} color="#000000" />
                                                    <span style={{ color: "#000" }}>
                                                        {state.fileState.isConverting ? "Converting attachment..." : "Validating attachment..."}
                                                    </span>
                                                </>
                                            ) : state.fileValidation.status === "success" ? (
                                                <>
                                                    <BiSolidCheckCircle size={18} color="#2e7d32" />
                                                    <span style={{ color: "#2e7d32", fontWeight: 500 }}>Attachment OK</span>
                                                </>
                                            ) : state.fileValidation.status === "failure" ? (
                                                <>
                                                    <BiSolidError size={18} color="#d32f2f" />
                                                    <span style={{ color: "#d32f2f", fontWeight: 500, whiteSpace: "pre-line" }}>
                                                        {state.fileValidation.message}
                                                    </span>
                                                </>
                                            ) : (
                                                <span style={{ color: "#666" }}>Select a file to validate (optional).</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {modal.kind === "cancel" && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="cancel-reason" className="required">
                                        {t("selectCancellationOption")}
                                    </label>
                                    <select
                                        id="cancel-reason"
                                        required
                                        value={state.cancelForm.reason}
                                        onChange={(e) => actions.setCancelReason(e.target.value)}
                                    >
                                        <option value="" disabled>{t("selectOption")}</option>
                                        <option value={t("restaurantResolvedIssue")}>{t("restaurantResolvedIssue")}</option>
                                        <option value={t("issueStoppedOccurring")}>{t("issueStoppedOccurring")}</option>
                                        <option value={t("Other")}>{t("Other")}</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="cancel-comments">{t("additionalComments")}</label>
                                    <textarea
                                        id="cancel-comments"
                                        rows={5}
                                        value={state.cancelForm.comments}
                                        onChange={(e) => actions.setCancelComments(e.target.value)}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div className="modal-footer">
                        {modal.kind === "message" && !modal.uncloseable && (
                            <button className="incident-buttons" type="button" onClick={actions.closeModal}>
                                {t("cancel")}
                            </button>
                        )}

                        {modal.kind === "update" && (
                            <>
                                <button
                                    className="incident-buttons"
                                    type="button"
                                    disabled={!state.canSubmitUpdate}
                                    onClick={actions.submitUpdate}
                                >
                                    {t("updateIncident")}
                                </button>

                                <button className="incident-buttons" type="button" onClick={actions.closeModal}>
                                    {t("cancel")}
                                </button>
                            </>
                        )}

                        {modal.kind === "cancel" && (
                            <>
                                <button
                                    className="incident-buttons"
                                    type="button"
                                    disabled={!state.cancelForm.reason}
                                    onClick={actions.submitCancel}
                                >
                                    {t("requestCancellation")}
                                </button>

                                <button className="incident-buttons" type="button" onClick={actions.closeModal}>
                                    {t("returnToMenu")}
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </form>
    );
}